import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'immocapital',
  description:
    'Binance Smart Chain (BSC) tokens info and their charts',
  image: '',
}

export const customMeta: { [key: string]: PageMeta } = {
  '/': {
    title: 'Dashboard',
    description : 'immocapital'
  },
  '/login': {
    title: 'immocapital login',
    description : 'Login into system'
  },
  '/forgot-password': {
    title: 'immocapital reset password',
    description : 'Reset Password into system'
  }
}
